import React, {Component} from 'react';
import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../../services/authService';
import http from '../../../services/httpService';
import InputNotification from '../../common/InputNotification';
import InputRegular from '../../common/InputRegular';
import Header from '../Header'
import {Link} from 'react-router-dom'
// import ReactGA from "react-ga";

class FeedName extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                name: ''
            },
            fieldsCheckActive: false,
            errorsList: [],
            spinnerActive: false,
            unsuccessfulPostCall: false,
            errors: {},
            returnToScreen: '',
            teamSelected: ''
        };
    }

doSubmit = async () => {
    // ReactGA.event({
    //     category: 'Click',
    //     action: 'Name your workspace - Next',
    //     userId: getCurrentUserId(),
    //     label: '',
    //     nonInteraction: true
    // });
    await this.setState({spinnerActive: true, fieldsCheckActive: true})
    setTimeout(async ()=>{
        let anyErrorActive = await this.state.data.name ? false : true;
        await this.state.errorsList.map(error=>error ? anyErrorActive = true : '')
        if(!anyErrorActive){
            if(this.state.returnToScreen){
                try {
                    const feed_id = localStorage.feed_id;
                    this.setState({ spinnerActive: false })
                    // console.log(feed_id)
                    // const result = await http.patch('api/feed/' + feed_id, { name: this.state.data.name}, {headers: {authorization: getJwt()}});
                    /* Should be checked if feed name can be patch-ed */
                } catch(ex) {
                    if(ex.response && ex.response.status === 404)
                        this.setState({ spinnerActive: false })
                    toastr.error("Error Code #10054: We were unable to change your workspace name. Please try again.");
                    if(ex.response && ex.response.status === 401){
                        this.setState({ spinnerActive: false })
                        toastr.error('Error Code #10055: '+ex.response.data.message);
                        this.props.history.push('/logout');
                    }
                }

            } else if(this.state.teamSelected){
                this.setState({ spinnerActive: true })
                await localStorage.setItem("name", this.state.data.name);
                try {
                    // console.log('feed name: ', localStorage.name);
                    const newFeedResult = await http.post('api/user/' + getCurrentUserId() + '/source', {name: this.state.data.name}, {headers: {authorization: getJwt()}});

                    await localStorage.setItem("feed_id", JSON.stringify(newFeedResult.data.id));
                    await localStorage.setItem("source_clicked", JSON.stringify(newFeedResult.data.id));
                    await this.props.selectSource(newFeedResult.data);

                    // console.log('new feed: ', newFeedResult);
                    try {
                        const feedToTeam = await http.post('/api/user/' + getCurrentUserId() + '/team/feed/' + newFeedResult.data.id, {team_id: this.state.teamSelected}, {headers: {authorization: getJwt()}})
                        // console.log('feed to team response: ', feedToTeam);
                        this.props.updateUser(
                            {
                                sources: {
                                    data: [
                                        ...this.props.user.sources.data,
                                        newFeedResult.data
                                    ]
                                }
                            }
                        )
                        this.props.appPropagateUserPlatforms([]);
                        this.props.updateUserFromServer();
                        // this.props.history.push('/feed-source');
                        this.props.history.push('/subscription-plans');
                        this.setState({ spinnerActive: false })
                        // console.log('feed id: ', newFeedResult.data.id);
                    } catch (ex) {
                        this.setState({spinnerActive: false});
                        if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                            const errors_obj = this.state.errors;
                            let errors = {...errors_obj};
                            errors = ex.response.data.errors;
                            this.setState({errors});
                        }
                        if (ex.response && ex.response.status === 401) {
                            const errors_obj = this.state.errors;
                            let errors = {...errors_obj};
                            errors.email = ex.response.data.message;
                            this.setState({errors});
                        }
                    }


                } catch (ex) {
                    this.setState({spinnerActive: false});
                    if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                        const errors_obj = this.state.errors;
                        let errors = {...errors_obj};
                        errors = ex.response.data.errors;
                        this.setState({errors});
                    }
                    if (ex.response && ex.response.status === 401) {
                        const errors_obj = this.state.errors;
                        let errors = {...errors_obj};
                        errors.email = ex.response.data.message;
                        this.setState({errors});
                    }
                }
            } else {
                localStorage.setItem("name", this.state.data.name);
                this.setState({ spinnerActive: false })
                this.props.history.push('/choose-team');
            }
        } else {
            this.setState({ spinnerActive: false })
        }
    }, 1000)
};

checkInputNotification = () => {
    if (this.state.unsuccessfulPostCall) {
        return <InputNotification type={'danger'} text={'Not been able to create New Feed. Please try again.'}/>
    }
};

updateErrorsList = async (error, id) => {
    let errorsList = await this.state.errorsList;
    errorsList[parseInt(id) - 1] = await error;
    await this.setState({errorsList})
    //console.log('errorsList: ', errorsList)
}

componentDidMount()
{
  //  ReactGA.pageview(window.location.pathname + window.location.search);
    const oldFeedName = this.props.location.state ? this.props.location.state.oldFeedName : '';
    const returnToScreen = this.props.location.state ? this.props.location.state.returnToScreen : '';
    const teamSelected = this.props.location.state ? this.props.location.state.teamSelected : '';
    if (oldFeedName || returnToScreen || teamSelected) {
        this.setState({
            data: {
                name: oldFeedName
            },
            returnToScreen,
            teamSelected
        })
    }
}

render()
{

    return (
        <div className='onboarding-container'>
            <Header linkDisabled={true}/>
            <div className="onboarding-content">
                <div className="onboarding-panel">
                    <h1 className='onboarding-title'>Workspace name</h1>
                    <p className='m-m-b'><strong>Workspace</strong> is a group of online resources that you want to <br/>
                        manage and automate. <br/><br/>
                        {/*It consists of: <br/><br/>*/}
                        {/*<strong>1. Content sources</strong> - Websites and URLs from which Emitto*/}
                        {/*can fetch the content to be posted automatically <br/>*/}
                        {/*<strong>2. Distribution channels</strong> - online platforms you want <br/>*/}
                        {/*to use for broadcasting messages with Emitto.<br/>*/}
                    </p>


                    <div className='margin-top-20 margin-bottom-30'>
                        <InputRegular
                            id="1"
                            label1=""
                            label2=""
                            placeholder="Enter Workspace Name"
                            type='project-name'
                            onChange={ async (value)=> await this.setState({ data: {
                                    name: value
                                }}) }
                            value={this.state.data.name}
                            required={true}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="Name has to contain at least one letter (upper case A-Z, lower case a-z), numbers 0-9 and spaces. No special characters are allowed."
                            spaceBellowInput={30}
                        />

                    </div>
                    {/*{this.renderInput('name', 'text', 'Ex. My Website','','')}*/}
                    {/*{this.checkInputNotification()}*/}
                    {this.state.spinnerActive ?
                        <button className='btn-action btn-spinner margin-bottom-30 margin-top-10' disabled={true}>Next  <i className='fa fa-spin fa-spinner'></i></button>
                        :
                        <button className='btn-action margin-bottom-30 margin-top-10' onClick={this.doSubmit}>Next</button>
                    }

                    <div className='panel-message text-center'>
                        <p>Or, <Link to="#" onClick={() => {
                            this.props.history.push(localStorage.navigateBackTo ? localStorage.navigateBackTo : this.state.returnToScreen || '/dashboard')
                            localStorage.removeItem('selectedTeam');
                            localStorage.removeItem('navigateBackTo');
                        }}>cancel</Link></p>
                    </div>
                </div>

            </div>

        </div>
    )
}
}

export default FeedName;